export const PRODUCT_TYPES = [
  "Current Owner Search",
  "Two Owner Search",
  "Full Search",
  "Update/Bring Down Search",
  "Tax Search",
  "Typing",
  "Document Retrieval",
  "Mortgage Search",
  "Assignment Verification Search",
  "Deeds and Chains Search",
  "Legal and Vesting Request",
];

export const WORKFLOWS = {
  "Current Owner Search": {
    fields: [
      { key: "current_owner", label: "Current Owner", type: "text" },
      { key: "deed_reference", label: "Deed Reference (Book/Page)", type: "text" },
      { key: "open_mortgages", label: "Open Mortgages", type: "textarea" },
      { key: "effective_date", label: "Effective Date", type: "date" },
      { key: "notes", label: "Notes", type: "textarea" },
    ],
  },
  "Two Owner Search": {
    fields: [
      { key: "search_period", label: "Search Period (Two Owners)", type: "text" },
      { key: "grantor", label: "Grantor", type: "text" },
      { key: "grantee", label: "Grantee", type: "text" },
      { key: "current_vesting", label: "Current Vesting", type: "textarea" },
      { key: "deed_reference", label: "Deed Reference (Book/Page)", type: "text" },
      { key: "open_mortgages", label: "Open Mortgages / Deeds of Trust", type: "textarea" },
      { key: "notes", label: "Examiner Notes", type: "textarea" },
    ],
  },
  "Full Search": {
    fields: [
      { key: "search_period", label: "Search Period (Full / 40-60 yr)", type: "text" },
      { key: "current_vesting", label: "Current Vesting", type: "textarea" },
      { key: "chain_of_title", label: "Chain of Title", type: "textarea" },
      { key: "open_liens", label: "Open Liens & Mortgages", type: "textarea" },
      { key: "easements", label: "Easements & Restrictions", type: "textarea" },
      { key: "judgments", label: "Judgments / Tax Liens", type: "textarea" },
      { key: "effective_date", label: "Effective Date", type: "date" },
    ],
  },
  "Update/Bring Down Search": {
    fields: [
      { key: "prior_effective_date", label: "Prior Effective Date", type: "date" },
      { key: "updated_through", label: "Updated Through", type: "date" },
      { key: "new_matters", label: "New Matters Found", type: "textarea" },
      { key: "status_notes", label: "Status Notes", type: "textarea" },
    ],
  },
  "Tax Search": {
    fields: [
      { key: "tax_parcel", label: "Tax Parcel / APN", type: "text" },
      { key: "tax_year", label: "Tax Year", type: "text" },
      { key: "assessed_value", label: "Assessed Value ($)", type: "number" },
      { key: "amount_due", label: "Amount Due ($)", type: "number" },
      { key: "delinquencies", label: "Delinquencies", type: "textarea" },
      { key: "tax_notes", label: "Tax Notes", type: "textarea" },
    ],
  },
  "Typing": {
    fields: [
      { key: "examiner", label: "Examiner", type: "text" },
      { key: "typing_notes", label: "Typing Notes", type: "textarea" },
    ],
  },
  "Document Retrieval": {
    fields: [
      { key: "document_type", label: "Document Type", type: "text" },
      { key: "recording_reference", label: "Recording Reference (Book/Page/Instr.)", type: "text" },
      { key: "requested_docs", label: "Requested Documents", type: "textarea" },
      { key: "retrieval_notes", label: "Retrieval Notes", type: "textarea" },
    ],
  },
  "Mortgage Search": {
    fields: [
      { key: "mortgagor", label: "Mortgagor / Borrower", type: "text" },
      { key: "mortgagee", label: "Mortgagee / Lender", type: "text" },
      { key: "open_mortgages", label: "Open Mortgages / Deeds of Trust", type: "textarea" },
      { key: "assignments", label: "Assignments", type: "textarea" },
      { key: "notes", label: "Notes", type: "textarea" },
    ],
  },
  "Assignment Verification Search": {
    fields: [
      { key: "original_lender", label: "Original Lender", type: "text" },
      { key: "current_holder", label: "Current Holder", type: "text" },
      { key: "assignment_chain", label: "Assignment Chain", type: "textarea" },
      { key: "mers_min", label: "MERS MIN #", type: "text" },
      { key: "notes", label: "Notes", type: "textarea" },
    ],
  },
  "Deeds and Chains Search": {
    fields: [
      { key: "chain_of_title", label: "Chain of Title", type: "textarea" },
      { key: "deeds_found", label: "Deeds Found", type: "textarea" },
      { key: "gaps", label: "Gaps / Breaks in Chain", type: "textarea" },
      { key: "notes", label: "Notes", type: "textarea" },
    ],
  },
  "Legal and Vesting Request": {
    fields: [
      { key: "current_vesting", label: "Current Vesting", type: "textarea" },
      { key: "legal_description", label: "Legal Description", type: "textarea" },
      { key: "deed_reference", label: "Deed Reference (Book/Page)", type: "text" },
      { key: "parcel_id", label: "Parcel / Tax ID", type: "text" },
      { key: "notes", label: "Notes", type: "textarea" },
    ],
  },
};

export const REPORT_FIELDS = [
  { key: "vesting", label: "Vesting", type: "textarea" },
  { key: "legal_description", label: "Legal Description", type: "textarea" },
  { key: "tax_parcel", label: "Tax Parcel / APN", type: "text" },
  { key: "deed_reference", label: "Deed Reference (Book / Page)", type: "text" },
  { key: "effective_date", label: "Effective Date", type: "date" },
  { key: "examiner_notes", label: "Examiner Notes", type: "textarea" },
];

export const PRODUCT_META = {
  "Current Owner Search": { color: "text-emerald-300 bg-emerald-500/15 border-emerald-500/30" },
  "Two Owner Search": { color: "text-blue-300 bg-blue-500/15 border-blue-500/30" },
  "Full Search": { color: "text-violet-300 bg-violet-500/15 border-violet-500/30" },
  "Update/Bring Down Search": { color: "text-cyan-300 bg-cyan-500/15 border-cyan-500/30" },
  "Tax Search": { color: "text-amber-300 bg-amber-500/15 border-amber-500/30" },
  "Typing": { color: "text-slate-300 bg-white/10 border-white/15" },
  "Document Retrieval": { color: "text-teal-300 bg-teal-500/15 border-teal-500/30" },
  "Mortgage Search": { color: "text-indigo-300 bg-indigo-500/15 border-indigo-500/30" },
  "Assignment Verification Search": { color: "text-fuchsia-300 bg-fuchsia-500/15 border-fuchsia-500/30" },
  "Deeds and Chains Search": { color: "text-rose-300 bg-rose-500/15 border-rose-500/30" },
  "Legal and Vesting Request": { color: "text-orange-300 bg-orange-500/15 border-orange-500/30" },
};

export const STATUS_STAGES = [
  "Open Order",
  "InProgress for Search",
  "Search Completed",
  "InProgress for Typing",
  "Typing Completed",
  "InProgress for Final QC",
  "QC Completed",
  "Completed",
  "Submitted",
  "Cancelled",
  "Rejected",
  "Pending for Documents",
  "Tax Pending",
  "Need to Call for Taxes",
  "Abstractor Order Received",
  "Abstractor Pending",
  "Clarification Needed",
];

export const STATUS_META = {
  "Open Order": { color: "text-amber-800 bg-amber-100 border-amber-300" },
  "InProgress for Search": { color: "text-blue-800 bg-blue-100 border-blue-300" },
  "Search Completed": { color: "text-sky-800 bg-sky-100 border-sky-300" },
  "InProgress for Typing": { color: "text-indigo-800 bg-indigo-100 border-indigo-300" },
  "Typing Completed": { color: "text-purple-800 bg-purple-100 border-purple-300" },
  "InProgress for Final QC": { color: "text-violet-800 bg-violet-100 border-violet-300" },
  "QC Completed": { color: "text-green-800 bg-green-100 border-green-300" },
  "Completed": { color: "text-emerald-800 bg-emerald-100 border-emerald-300" },
  "Submitted": { color: "text-teal-800 bg-teal-100 border-teal-300" },
  "Cancelled": { color: "text-rose-800 bg-rose-100 border-rose-300" },
  "Rejected": { color: "text-red-800 bg-red-100 border-red-300" },
  "Pending for Documents": { color: "text-cyan-800 bg-cyan-100 border-cyan-300" },
  "Tax Pending": { color: "text-orange-800 bg-orange-100 border-orange-300" },
  "Need to Call for Taxes": { color: "text-red-800 bg-red-100 border-red-300" },
  "Abstractor Order Received": { color: "text-fuchsia-800 bg-fuchsia-100 border-fuchsia-300" },
  "Abstractor Pending": { color: "text-pink-800 bg-pink-100 border-pink-300" },
  "Clarification Needed": { color: "text-rose-800 bg-rose-100 border-rose-300" },
};
